import Vue from 'vue';
import Component from 'vue-class-component';

import SearchResult from 'components/DynamicFilters/SearchResult/SearchResult.vue';
import OptionCards from 'components/DynamicFilters/OptionCards/OptionCards.vue';
import FilterColumn from 'components/DynamicFilters/FilterColumn/FilterColumn.vue';
import SearchTags from 'components/DynamicFilters/SearchTags/SearchTags.vue';
import FilterColumnMobile from 'components/DynamicFilters/FilterMobile/FilterMobile.vue';
import SpinnerLoading from 'common/components/SpinnerLoading/SpinnerLoading.vue';
import OrderBy from 'components/DynamicFilters/OrderBy/OrderBy.vue';
import CarouselCategorySlider from 'components/CarouselCategorySlider/CarouselCategorySlider.vue';
import useFilters from 'composables/useFilters';
import { Watch } from 'vue-property-decorator';

@Component({
  components: {
    SearchResult,
    OptionCards,
    FilterColumn,
    SearchTags,
    FilterColumnMobile,
    SpinnerLoading,
    OrderBy,
    CarouselCategorySlider,
  },
  metaInfo() {
    // Get the canonical URL without parameters
    const canonicalUrl =
      window.location.protocol +
      '//' +
      window.location.host +
      window.location.pathname;

    // Define the domain
    const domain = window.location.host;

    let newtitle =
      'Bigbox: regalos para cumpleaños, aniversarios y más. Regalá experiencias únicas.';

    if (
      domain.includes('.cl') ||
      domain.includes('.com.mx') ||
      domain.includes('.com.co') ||
      domain.includes('.pe')
    ) {
      newtitle =
        'Bigbox: regalos para cumpleaños, aniversarios y más. Regala experiencias únicas.';
    }

    return {
      title: newtitle,
      link: [
        {
          rel: 'canonical',
          href: canonicalUrl, // Set the canonical URL without query parameters
          vmid: 'canonical',
        },
      ],
    };
  },
  setup() {
    const {
      getFacets,
      getCurrentFilters,
      getCurrentTags,
      getOptionCards,
      getCardSelected,
      getResults,
      getLoading,
      getPageInfo,
      setKeywords,
      getBoxes,
      getActivities,
      getTravel,
      getDataFromFilters,
      setCard,
      setBoxCategory,
      clearCurrentFilters,
      applyURLFilters,
      registerURLUpdateCallback,
      unregisterURLUpdateCallback,
      init,
    } = useFilters();
    return {
      facets: getFacets,
      currentFilters: getCurrentFilters,
      currentTags: getCurrentTags,
      cardSelected: getCardSelected,
      optionCards: getOptionCards,
      results: getResults,
      loading: getLoading,
      pageInfo: getPageInfo,
      getBoxes,
      setKeywords,
      getActivities,
      getTravel,
      getDataFromFilters,
      setCard,
      setBoxCategory,
      clearCurrentFilters,
      applyURLFilters,
      registerURLUpdateCallback,
      unregisterURLUpdateCallback,
      init,
    };
  },
})
export default class FiltersComponent extends Vue {
  resultsDescription = {
    0: 'Regalos con Opciones',
    1: 'Actividades',
    2: 'Viajes',
  };
  isInitializing = true;
  hasAppliedUrlFilters = false;

  async mounted() {
    this.isInitializing = true;
    this.hasAppliedUrlFilters = false;

    this.registerURLUpdateCallback(this.updateURLFromFilters.bind(this));

    try {
      await this.init();

      const cardFromUrl = parseInt(this.$route.query.card || 0);
      this.setCard(cardFromUrl);

      if (this.$route.query.currentFilters) {
        try {
          const currentFilters = this.$route.query.currentFilters;
          const parsedFilters = JSON.parse(currentFilters); 
          this.applyURLFilters(parsedFilters);
          this.hasAppliedUrlFilters = true;
        } catch (err) {
          // eslint-disable-next-line no-console
          console.error('ERROR applying URL filters:', err);
        }
      }

      this.setKeywords(this.$route.query.keywords || '');

      await this.getDataFromFilters();
    } finally {
      this.isInitializing = false;
    }
  }

  beforeDestroy() {
    this.unregisterURLUpdateCallback();
  }

  updateURLFromFilters(currentFilters, cardSelected) {
    if (this.isInitializing) return;

    this.$router
      .replace({
        name: this.$route.name,
        params: this.$route.params,
        query: {
          ...this.$route.query,
          currentFilters: JSON.stringify(currentFilters),
          card: cardSelected,
        },
      })
      .catch(err => {
        // Ignorar errores de navegación redundante
        if (err.name !== 'NavigationDuplicated') {
          // eslint-disable-next-line no-console
          console.error('Error updating URL:', err);
        }
      });
  }

  async updateCardSelected(skipFetch = false) {
    if (this.isInitializing) return;

    const newCardSelected = parseInt(this.$route.query.card || 0);
    this.setCard(newCardSelected);
    if (!skipFetch) {
      await this.getDataFromFilters();
    }
  }

  async clearKeywords() {
    this.$router.replace({
      name: 'products',
      query: { ...this.$route.query, keywords: '' },
    });
  }

  get isMobile() {
    return this.$screen.width < 991;
  }

  get keywords() {
    return this.$route.query.keywords;
  }

  async setKeywordsAndFetch() {
    if (this.isInitializing) return;

    this.setKeywords(this.$route.query.keywords || '');
    await this.getDataFromFilters();
  }

  @Watch('$route.query.keywords')
  onChangeKeywords() {
    this.setKeywordsAndFetch();
  }

  @Watch('$route.query.card')
  onRouteQueryCardChange() {
    this.updateCardSelected();
  }

  @Watch('$route.query.currentFilters')
  async onCurrentFiltersQueryChange(newFilters, oldFilters) {
    // Solo actuar si cambió, no estamos inicializando, y ya aplicamos filtros URL iniciales
    if (
      newFilters !== oldFilters &&
      newFilters &&
      !this.isInitializing &&
      this.hasAppliedUrlFilters
    ) {
      try {
        const parsed = JSON.parse(newFilters);
        this.applyURLFilters(parsed);
        await this.getDataFromFilters();
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('ERROR applying URL filters from route change:', err);
      }
    }
  }
}
